import React from 'react';
import { View, Text } from 'react-native';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { t } from 'react-native-tailwindcss';
import { MediumText } from '../atoms/MediumText';

export const ZaiTerms = (): React.ReactElement => {
  const navigation = useNavigation<NavigationProp<any>>();

  return (
    <>
      <MediumText>
        By selecting a funding account, you are agreeing to Zai's terms and
        conditions which can be found here:{'\n \n'}
        <Text
          style={styles.coloredLink}
          onPress={() => navigation.navigate('DDR')}
        >
          Zai Direct Debit Request{'\n'}
        </Text>
        <Text
          style={styles.coloredLink}
          onPress={() => navigation.navigate('DDRSA')}
        >
          Zai Direct Debit Request Service Agreement
        </Text>
        {'\n \n'}
        <View style={{ marginBottom: 16 }}>
          <MediumText style={{ fontWeight: 'bold', marginBottom: 8 }}>
            Amount of debit{'\n'}
          </MediumText>
          <MediumText>
            Any amount PokitPal has deemed payable by you, including but not
            limited to mandatory reversals, refunds, administrative fees and
            other costs and liabilities.{'\n \n'}
          </MediumText>
        </View>
        <View style={{ marginBottom: 16 }}>
          <MediumText style={{ fontWeight: 'bold', marginBottom: 8 }}>
            Acknowledgment{'\n'}
          </MediumText>
          <MediumText>
            By signing and/or providing us with a valid electronic instruction
            in respect to your Direct Debit Request you confirm that:{'\n'}- You
            are authorised to operate the nominated account; and{'\n'}- You are
            authorising in accordance with the account authority on your
            nominated account; and{'\n'}- You have understood and agreed to the
            terms and conditions set out in this Request and in your Direct
            Debit Request Service Agreement.
          </MediumText>
        </View>
      </MediumText>
    </>
  );
};

const styles = {
  coloredLink: [t.textBlue400, t.underline],
};
